export default function getNestedChildren(arr, parent) {
  const out = [];
  // eslint-disable-next-line no-console
  console.log(arr);
  for (var i in arr) {
    if (arr[i].parent_id === parent) {
      var children = getNestedChildren(arr, arr[i].comment_id);

      if (children.length) {
        arr[i].child = children;
      }
      out.push(arr[i]);
    }
  }
  return out;
}
